import { mapState } from 'vuex';
import ApiService from '@/services/apiService';

export default {
  data() {
    return {
      accountFilterReady: false,
      selectedAccounts: [],

      searchItems: [],

      searchTags: [],
      searchZones: [],
      loadingData: {
        tags: false,
        zones: false,
      },
    };
  },
  computed: {
    ...mapState('app', ['language']),
    loadingDataDone() {
      return Object.values(this.loadingData).every((value) => value);
    },
    searchTypes() {
      return [
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.title'),
          param: 'title',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.id'),
          param: 'id',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.tag'),
          param: 'tag',
          items: [],
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
          param: 'keyValue',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.zone'),
          param: 'zone',
          items: [],
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['floorDtwin.name'],
          param: 'floorDtwin.name',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['floorDtwin.number'],
          param: 'floorDtwin.number',
        },
      ];
    },
  },
  watch: {
    language() {
      (this.searchTypes.find((item) => item.param === 'tag') || {}).items = this.tagList;
      (this.searchTypes.find((item) => item.param === 'zone') || {}).items = this.zoneList;
    },
  },
  methods: {
    fetchTagsAndZones() {
      ApiService.digitalTwinFetchTagsAndZones(this)
        .then((res) => {
          this.tagList = res.tagList;
          this.zoneList = res.zoneList;
          (this.searchTypes.find((item) => item.param === 'tag') || {}).items = this.tagList;
          (this.searchTypes.find((item) => item.param === 'zone') || {}).items = this.zoneList;
        })
        .catch((error) => {
          console.error('Error fetching categories and zones', error);
        });
    },
    resetLoadingData() {
      for (const key in this.loadingData) {
        this.loadingData[key] = false;
      }
    },
    getMultiFilterData() {
      this.resetLoadingData();
      this.fetchTagsAndZones();
    },
    searchUpdated(search) {
      this.searchItems = search;
      this.fetchList(true);
    },
  },
};
